import {Injectable} from '@angular/core';

export class Dw2dScanCode {
    gtin: string;
    ndc: string;
    serialNumber: string;
    expirationDate: string;
    lotNumber: string;
    error: string;

    endTokens = ['17', '029'];
    constructor() {
        this.gtin = '';
        this.ndc = '';
        this.serialNumber = '';
        this.expirationDate = '';
        this.lotNumber = '';
        this.error = '';
    }
}
@Injectable({providedIn: 'root'})
export class DwCodes  {

    public static fieldStart = 0;

    public static parse2DScanCode(inp: string): Dw2dScanCode {

        const record: Dw2dScanCode = new Dw2dScanCode();
        let i = 0;
        let nextStart = 2;
        let incr = 0;
        let token = '';
        let firstSpin = true;

        if (inp === undefined) {
            record.error = 'Error: The scanned item was not defined';
            return record;
        }

        /** get the GTIN number **/
        record.gtin = inp.substring(2, 16);
        /** take the NDC number from the GTIN **/
        record.ndc = this.returnNDCFromScan(record.gtin);
        token = inp.substr(16, 2);
        this.fieldStart = 18;

        while (token.length > 0) {
            switch (token) {
                case '17': /** expiration date **/
                    if (!firstSpin) this.fieldStart += 2;
                    record.expirationDate = this.returnExpirationDate(inp.substr(this.fieldStart, 6));
                    this.fieldStart += 6;
                    token = this.getNextToken(inp, this.fieldStart);
                    break;
                case '10':  /** the lot number**/
                    if (!firstSpin) this.fieldStart += 2;
                    record.lotNumber = this.returnSerialNumber(inp, this.fieldStart);
                    token = this.getNextToken(inp, this.fieldStart);
                    break;
                case '21':  /** The Serial Number **/
                    if (!firstSpin) this.fieldStart += 2;
                    record.serialNumber = this.returnSerialNumber(inp, this.fieldStart);
                    token = this.getNextToken(inp, this.fieldStart);
                    break;
                default:
                    token = '';
                    break;
            }
            firstSpin = false;
        }

        return record;
    }
    public static getNextToken(inp: string, startPos: number): string {

        let retVal = '';

        if(startPos >= inp.length) {
            return retVal;
        }

        retVal = inp.substr(startPos, 2);

        return retVal;
    }
    public static returnExpirationDate(inp: string): string {

        let retVal = '20';
        let nextStart = 0;
        let incr = 0;

        if (inp === undefined) { return retVal; }

        for (let i = nextStart; i < inp.length; i++) {

            if (inp[i] + inp[i + 1] === '10') {
                nextStart = i + 2;
                break;
            }
            incr ++;

            retVal += inp[i];

            if (incr === 2 || incr === 4) {
                retVal  += '-';
            }
        }
        return retVal;
    }
    public static returnNDCFromScan(inp: string): string {

        let tmpStr = '';
        let retVal = '';
        let counter = -1;

        if (inp === undefined) { return retVal; }
        /** locate the ndc number unformatted **/
        tmpStr = inp.substring(3, 14);
        /** finally wind backwards, strip off the last character and add formatting **/

        for (let i = tmpStr.length - 2; i > - 1; i--) {
            counter++;
            if  (counter === 2 || counter === 5) {
                retVal += '-';
            }
            retVal += tmpStr[i];

        }
        /** reverse the string so that it is the right way round **/
        return retVal.split('').reverse().join('');
    }
    public static returnSerialNumber(inp: string, startPos: number): string {
        let retVal = '';
        let tLen = 0;
        let index = inp.indexOf('029');
        let incr = 0;

        if (index === -1) {
            index = inp.indexOf('17');
        }
        else {
            incr = 3;
        }

        if ((index !== -1) && (index > startPos)) {
            /* field end marker */
            tLen = index - startPos;
            this.fieldStart += (tLen + incr);
        }
        else {
            /* read to end of line */
            tLen = inp.length - startPos;
            this.fieldStart += tLen;
        }
        retVal = inp.substr(startPos, tLen);

        return retVal;
    }
}
